import { createAction } from 'redux-actions';

export const getListProductRequested = createAction('GET_LIST_PRODUCT_REQUESTED');
export const getListProductReceived = createAction('GET_LIST_PRODUCT_RECEIVED');
export const getListProductReceivedFailure = createAction('GET_LIST_PRODUCT_RECEIVED_FAILURE');
export const clearListProduct = createAction('CLEAR_LIST_PRODUCT');

export const getListHistoryOrderRequested = createAction('GET_LIST_HISTORY_ORDER_REQUESTED');
export const getListHistoryOrderReceived = createAction('GET_LIST_HISTORY_ORDER_RECEIVED');
export const getListHistoryOrderReceivedFailure = createAction('GET_LIST_HISTORY_ORDER_RECEIVED_FAILURE');
export const clearListHistoryOrder = createAction('CLEAR_LIST_HISTORY_ORDER');

export const getDetailHistoryProductRequested = createAction('GET_DETAIL_HISTORY_PRODUCT_REQUESTED');
export const getDetailHistoryProductReceived = createAction('GET_DETAIL_HISTORY_PRODUCT_RECEIVED');
export const getDetailHistoryProductReceivedFailure = createAction('GET_DETAIL_HISTORY_PRODUCT_RECEIVED_FAILURE');
export const clearDetailHistoryProduct = createAction('CLEAR_DETAIL_HISTORY_PRODUCT');

export const getUserProfileRequested = createAction('GET_USER_PROFILE_REQUESTED');
export const getUserProfileReceived = createAction('GET_USER_PROFILE_RECEIVED');
export const getUserProfileReceivedFailure = createAction('GET_USER_PROFILE_RECEIVED_FAILURE');
export const clearGetUserProfile = createAction('CLEAR_GET_USER_PROFILE');

export const deleteProductRequested = createAction('DELETE_PRODUCT_REQUESTED');
export const deleteProductReceived = createAction('DELETE_PRODUCT_RECEIVED');
export const deleteProductReceivedFailure = createAction('DELETE_PRODUCT_RECEIVED_FAILURE');
export const clearDeleteProduct = createAction('CLEAR_DELETE_PRODUCT');

export const changeQuantityProductRequested = createAction('CHANGE_QUANTITY_PRODUCT_REQUESTED');
export const changeQuantityProductReceived = createAction('CHANGE_QUANTITY_PRODUCT_RECEIVED');
export const changeQuantityProductReceivedFailure = createAction('CHANGE_QUANTITY_PRODUCT_RECEIVED_FAILURE');
export const clearChangeQuantity = createAction('CLEAR_CHANGE_QUANTITY');

export const orderProductRequested = createAction('ORDER_PRODUCT_REQUESTED');
export const orderProductReceived = createAction('ORDER_PRODUCT_RECEIVED');
export const orderProductReceivedFailure = createAction('ORDER_PRODUCT_RECEIVED_FAILURE');
export const clearOrderProduct = createAction('CLEAR_ORDER_PRODUCT');

export const getCountProductRequested = createAction('GET_COUNT_PRODUCT_REQUESTED');
export const getCountProductReceived = createAction('GET_COUNT_PRODUCT_RECEIVED');
export const getCountProductReceivedFailure = createAction('GET_COUNT_PRODUCT_RECEIVED_FAILURE');
export const clearCountProduct = createAction('CLEAR_COUNT_PRODUCT');
